export function callbackWithoutPropagationComposer(callback) {
  return function callbackWrapper(event) {
    callback(event)
  }
}